import { EMAIL_TYPES } from 'constants/logic';
import { CAMPAIGN_TYPE } from 'features/Campaigns/Campaigns.helpers';

export const EMAIL_MESSAGE_TYPE_BY_EMAIL_TYPE = {
  [EMAIL_TYPES.GENERIC]: 'Email class',
  [EMAIL_TYPES.GENERIC_TO_NEW_USERS]: 'Email new users',
  [EMAIL_TYPES.GENERIC_TO_SOME_USERS]: 'Email member',
};

export const SMARTSPOT_UPDATE_SOURCE = {
  SMART_TOOLS: 'smart tools',
  OPPORTUNITIES: 'opportunities',
};

export const OPPORTUNITY_ACT_SOURCE = {
  SCHEDULE: 'schedule',
  OPPORTUNITIES: 'opportunities',
};

export const CAMPAIGN_CATEGORY = {
  NEW_USER: 'new user',
  WIN_BACK: 'win back',
  GENERAL: 'general',
};

export const CAMPAIGN_TYPE_TO_CAMPAIGN_CATEGORY = {
  [CAMPAIGN_TYPE.ALL_USER]: CAMPAIGN_CATEGORY.GENERAL,
  [CAMPAIGN_TYPE.NEW_USER]: CAMPAIGN_CATEGORY.NEW_USER,
  [CAMPAIGN_TYPE.WINBACK]: CAMPAIGN_CATEGORY.WIN_BACK,
};

export const CLASS_STATUS_CHANGE_SOURCE = {
  INDEX_PAGE: 'index page',
  CLASS_PAGE: 'class page',
};
